import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHarmonyMonochrome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5ZM12 11.5V5.5M12 5.5C11.2185 5.5 10.5766 4.90236 10.5064 4.13919M12 5.5C12.7815 5.5 13.4234 4.90236 13.4936 4.13919M10.5064 4.13919C10.5022 4.09336 10.5 4.04693 10.5 4C10.5 3.17157 11.1716 2.5 12 2.5C12.8284 2.5 13.5 3.17157 13.5 4C13.5 4.04693 13.4978 4.09336 13.4936 4.13919M10.5064 4.13919C6.80192 4.83877 4 8.09217 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 8.09217 17.1981 4.83877 13.4936 4.13919",
		stroke: "#f0f0f0"
	})
});
export default SvgHarmonyMonochrome;
